import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './styled/Button';

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'th' : 'en';
    i18n.changeLanguage(newLanguage);
  };

  return (
    <Button
      variant="ghost"
      size="md"
      onClick={toggleLanguage}
      className={className}
    >
      {i18n.language === 'en' 
        ? 'Switch to Thai (ภาษาไทย)' 
        : 'เปลี่ยนเป็นภาษาอังกฤษ (EN)'}
    </Button>
  );
};

export default LanguageSwitcher;
